<template>
  <Layout>
      
    <!-- <Banner v-if="!reference && !selectedSubGroupName" :pageTitle="pageTitle ? pageTitle :'Notre Catalogue'" :bannerImageName="bannerImageName" :small="true" ></Banner> -->

    <Shop @bannerTitle="bannerTitle" @catalogBannerImage="catalogBannerImage" > </Shop>





  </Layout>


  

  
</template>

<script>
import Layout from "../../layouts/main";
//import Banner from "@/components/banner.vue"
import Shop from "@/components/shopComponent.vue"

export default ({
  name: "Catalogue",
  page: {
    titleTemplate(title) {

       let pageTitle = '';
       if (this.$route.params.section && !this.$route.params.group && !this.$route.params.subgroup) {
            pageTitle = 'Collection ' + this.$route.params.section;
        }

        if (this.$route.params.section && this.$route.params.group && !this.$route.params.subgroup) {
          pageTitle =  this.$route.params.group + " " + this.$route.params.section ;
        }

        if (this.$route.params.section && this.$route.params.group && this.$route.params.subgroup) {
          pageTitle = this.$route.params.subgroup + " " + this.$route.params.section ;
        }

        return pageTitle ? pageTitle.replace(/\b\w/g, char => char.toUpperCase()) + ' | HA, Boutique en ligne, Tunisie' : title;
    }
  },

  components: {
    Layout, /*Banner,*/ Shop
  },

  props: {
        
    },

    data() {
        return { 
            reference: null,
            pageTitle:null,
            selectedSubGroupName:null,
            bannerImageName:null,
        }
    },

    watch :{

        '$route': {
            immediate: true,
            deep: true, 
            handler(route) {
              this.selectedSubGroupName = route.params.subgroup;

                if (route.query.keyword) {
                    this.reference = route.query.keyword;
                } else {
                    this.reference = null;
                }
            }
        },

        

    },


  mounted() {
  },

  methods: {

    bannerTitle(bannerTitle ){
      this.pageTitle = bannerTitle

    },

    catalogBannerImage(bannerImageName){
      this.bannerImageName = bannerImageName
    }
  },


});
</script>

<style scoped>

</style>



